/*!
 *
 * Copyright 2019 Dmitry Chuba
 */

const Hash = require('./hash');

(function (factory) {
    if (typeof define === 'function' && define.amd) {
        // AMD
        define(['jquery'], factory);
    } else if (typeof exports === 'object') {
        // CommonJS
        factory(require('jquery'));
    } else {
        // Browser globals
        factory(jQuery);
    }
}(function ($) {
    'use strict';

    $.fn.subExpandable = function () {

        const seContainer = $(this);
        const hash        = Hash.val;
        if (hash.length > 0) {
            seContainer
                .find(`.current :not(.item-link[href*="#${hash}"])`)
                .parents('.current')
                .removeClass('current');
        }

				seContainer.find('.has-submenu.open > .submenu, .submenu-item.active > .submenu').each(function () {
					let outerHeight = 150;
					let hasActive   = false;

					$(this).find('.submenu-item').each(function () {
							outerHeight += $(this).outerHeight(true);
							if ($(this).hasClass('current')) {
									hasActive = true;
							}
					});

					$(this).data('max-height', outerHeight);
					$(this).css('max-height', outerHeight);

				});

        seContainer.find('.item-link').on('click', function () {
          seContainer.find('.submenu-item.current').removeClass('current');
          $(this).parents('.submenu-item').addClass('current');
        });

        seContainer.find('.has-submenu .submenu-item').on('click', function (e) {

            e.stopPropagation();
        });
        seContainer.find('.has-submenu').on('click', function () {

            if ($(this).hasClass('active')) {
                $(this).removeClass('active')
            } else if($(this).hasClass('open')) {
							$(this).removeClass('open')
						} else {
                $(this).toggleClass('open');
            }
						seContainer.find('.has-submenu > .submenu').each(function() {
							$(this).css('max-height', 0);
						});
						seContainer.find('.has-submenu.open > .submenu, .submenu-item.active > .submenu').each(function () {
							let outerHeight = 150;
							let hasActive   = false;

							$(this).find('.submenu-item').each(function () {
									outerHeight += $(this).outerHeight(true);
									if ($(this).hasClass('current')) {
											hasActive = true;
									}
							});

							$(this).data('max-height', outerHeight);
							$(this).css('max-height', outerHeight);

						});


        });

        /*
        seContainer.find('.has-sub-items').on('click', function () {
            $(this).toggleClass('closed');
        });
        seContainer.find('.has-sub-items').on('mouseenter', function () {
            $(this).addClass('open');
        });

        seContainer.on('mouseleave', function () {
            $(this).find('.has-sub-items.open').removeClass('open');
        });
        */
        return this;
    };

}));
